<template>
  <div>
    <Layout v-if="loaded">
      <div class="grid grid-cols-1 gap-1 w-11/12 max-w-3xl mx-auto mt-12">
        <div v-if="uncompleteTasks.length > 0">
          <UserTaskPreviewCard v-for="task in uncompleteTasks" :key="`tasks.${task.id}`" :task="task" />
        </div>
        <ZeroState v-if="!uncompleteTasks || uncompleteTasks.length === 0">
          <p>You do not have any tasks assigned.</p>
        </ZeroState>
      </div>
    </Layout>
  </div>
</template>

<script>
import Layout from '../components/Layout/index.vue';
import { Api } from '../api/index.ts';
import UserTaskPreviewCard from '../components/user_tasks/UserTaskPreviewCard.vue';
import ZeroState from '../components/ZeroState.vue';

export default {
  components: {
    Layout,
    UserTaskPreviewCard,
    ZeroState,
  },
  data() {
    return {
      userTasks: [],
      loaded: false,
    };
  },
  computed: {
    uncompleteTasks() {
      return this.userTasks.filter(task => task.status !== 'completed');
    },
  },
  async mounted() {
    await this.fetchUserTasks();
    this.loaded = true;
  },
  methods: {
    async fetchUserTasks() {
      try {
        const { records } = await Api.UserTasks.listUserTasks();
        this.userTasks = records;
      } catch (error) {
        console.error('Failed to fetch user tasks:', error);
        this.userTasks = [];
      }
    },
  },
};
</script>
